import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons'

import './Filter.scss';

class Filter extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value || ''
		};
		this.handleChange = this.handleChange.bind(this);
		this.clear = this.clear.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}
	
	handleChange(e) {
		this.setState({[e.target.name]: e.target.value});
		if (this.props.onChange)
			this.props.onChange({target: {name: this.props.name, value: e.target.value}});
	}
	
	onSubmit(e) {
		if (this.props.onSubmit) 
			this.props.onSubmit(e);
		//e.preventDefault();
		//e.stopPropagation();
	}
	
	clear(e) {
		this.handleChange({target: {name: "value", value: ""}});
	}
	
	// Maybe do something on props change
	render() {
		const x = (this.state.value.length === 0) ? '' : <button className="clear" type="reset" onClick={this.clear}><FontAwesomeIcon icon={faTimesCircle}/></button>;
		return <div className={"Filter " + (this.props.className || "")} title={this.props.placeholder || ""}>
				<FontAwesomeIcon icon={faSearch} className="searchIcon" />
				<form onSubmit={this.onSubmit}>
					<input type="text" name="value" placeholder={this.props.placeholder || ""} value={this.state.value} onChange={this.handleChange} />
				</form>
					{x}
			</div>;
	}
}

export default Filter;